import Check from '../Check';
import Report from '../Report';
import { MessageType } from '../Message';
import type { IFSM } from '../../../stores/model/metamodel/fsm';

/**
 * Check for backward inaccessible states in an FSM
 */
class FSMBackwardInaccessibilityCheck extends Check<IFSM> {
  static description = 'Check backward inaccessibility';

  check(): Report {
    this.report = new Report();

    const inaccessible = this.element.backwardInaccessibleStates;
    if (inaccessible.length === 0) {
      this.report.addMessage(
        MessageType.INFORMATION,
        `No backward inaccessible states found.`,
        this,
        this.element
      );
    } else {
      this.report.addMessage(
        MessageType.WARNING,
        `Backward inaccessible states found: ${inaccessible.map(s => s.name).join(', ')}.`,
        this,
        this.element
      );
    }

    return this.report;
  }
}

export default FSMBackwardInaccessibilityCheck;
